import {HTMLProps} from "react";

export const TableCellKey = (props: HTMLProps<HTMLTableCellElement>) => (
    <td className={"text-grey--400 font-medium align-top py-1"}>{props.children}</td>
)

export const TableCellValue = (props: HTMLProps<HTMLTableCellElement>) => (
    <td className={"text-black align-top pl-4 py-1"}>{props.children}</td>
)